import eproTheme from "./epro/theme.ts";
import { Preset } from "@primeuix/themes/types";
export const themes: Record<string, Preset> = {
  epro: eproTheme,
};
